import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { PageTitleService } from 'common/util/module'

@Component({
  selector: 'four-oh-four-view',
  templateUrl: './404View.component.pug',
  styleUrls: ['./404View.component.scss'],
})
export class FourOhFourView {
  constructor (pageTitle: PageTitleService, translate: TranslateService) {
    pageTitle.set(translate.instant('Not found'))
  }
}
